
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Regulation',
  props: {
    dataRule: {
      type: String,
      default: ''
    }
  }
})
